<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/structure/MyFile' }">我的档案</el-breadcrumb-item>
                    <el-breadcrumb-item>补全信息</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-form :model="fulluser" style="font-size:12px;" :rules="rules" ref="ruleForm" label-width="100px"
            class="demo-ruleForm">
            <el-row class="font_left">
                <el-col :span="4">
                    <div>
                        <el-upload accept="image/jpeg,image/gif,image/png,image/jpg" action=""
                            :data="{ name: 'sysUser.HeadImg' }" :http-request="uploadImage"
                            class="avatar-uploader el-upload" :before-upload="beforeAvatarUpload"><img
                                v-if="fulluser.sysUser.HeadImg" :src="fulluser.sysUser.HeadImg" class="avatar"><i v-else
                                class="el-icon-plus avatar-uploader-icon"></i></el-upload>
                    </div>
                </el-col>
                <el-col :span="20">
                    <el-row class="font_left">
                        <el-col :span="6">
                            <el-form-item size="small" label="姓名" label-width="150px">
                                <el-input v-model="fulluser.sysUser.TrueName" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item size="small" label="招聘来源" label-width="150px">
                                <el-input v-model="fulluser.userBase.RecruitIncome" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item size="small" label="薪酬体系" label-width="150px">
                                <el-select v-model="fulluser.userBase.SalaryID" placeholder="请选择薪酬体系">
                                    <el-option v-for="v in type" :label="v.ClassName" :key="v.Id"
                                        :value="v.Id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item size="small" label="当前部门" label-width="150px">
                                <el-input v-model="fulluser.sysUser.MainDeptsName" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item size="small" label="政治面貌" label-width="150px" prop="politcal">
                                <el-select v-model="fulluser.userBase.Politcal" placeholder="请选择政治面貌">
                                    <el-option label="党员" value="党员"></el-option>
                                    <el-option label="预备党员" value="预备党员"></el-option>
                                    <el-option label="团员" value="团员"></el-option>
                                    <el-option label="群众" value="群众"></el-option>
                                    <el-option label="其他" value="其他"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item size="small" label="身份证签发机关" label-width="150px" prop="psb">
                                <el-input v-model="fulluser.userBase.PSB"></el-input>
                            </el-form-item>
                            <!-- <el-form-item size="small" label="持有银行的工资卡" label-width="150px" prop="isPossess">
                                <el-select v-model="fulluser.userBase.IsPossess" placeholder="请选择持有银行的工资卡">
                                    <el-option label="无" value="0"></el-option>
                                    <el-option label="中信" value="1"></el-option>
                                    <el-option label="浙商" value="2"></el-option>
                                    <el-option label="广发" value="3"></el-option>
                                    <el-option label="光大" value="4"></el-option>
                                    <el-option label="民生" value="5"></el-option>
                                    <el-option label="华夏" value="6"></el-option>
                                    <el-option label="邮政" value="7"></el-option>
                                </el-select>
                            </el-form-item> -->
                        </el-col>
                        <el-col :span="8">
                            <el-form-item size="small" label="员工编号" label-width="150px">
                                <el-input v-model="fulluser.sysUser.UserCode" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item size="small" label="公司邮箱" label-width="150px">
                                <el-input v-model="fulluser.sysUser.UserName"></el-input>
                            </el-form-item>
                            <el-form-item size="small" label="岗位类别" label-width="150px">
                                <el-select v-model="fulluser.sysUser.DutyTypeId" placeholder="请选择岗位类别">
                                    <el-option v-for="v in dutyType" :label="v.ClassName" :key="v.Id"
                                        :value="v.Id"></el-option>
                                    <!-- <el-option label="否" value="0"></el-option> -->
                                </el-select>
                            </el-form-item>
                            <el-form-item size="small" label-width="150px" label="入职时间">
                                <el-form-item prop="HiredDate">
                                    <el-date-picker type="date" placeholder="选择入职时间"
                                        v-model="fulluser.userBase.HiredDate" style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </el-form-item>
                            <el-form-item size="small" label="民族" label-width="150px" prop="nature">
                                <el-input v-model="fulluser.userBase.Nature"></el-input>
                            </el-form-item>
                            <el-form-item size="small" label="身份证截止日期" label-width="150px">
                                <el-form-item prop="ExpirationTime">
                                    <el-date-picker type="date" placeholder="选择日期"
                                        v-model="fulluser.userBase.ExpirationTime"
                                        style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </el-form-item>
                            <!-- <el-form-item size="small" label="工资卡卡号" label-width="150px">
                                <el-input v-model="fulluser.userBase.CardNo"></el-input>
                            </el-form-item> -->
                        </el-col>
                        <el-col :span="8">
                            <el-form-item size="small" label="手机号" label-width="150px" prop="name">
                                <el-input v-model="fulluser.sysUser.Phone" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item size="small" label="地区" label-width="150px" prop="region">
                                <el-select v-model="fulluser.sysUser.Region" placeholder="请选择地区">
                                    <el-option label="郑州" value="郑州"></el-option>
                                    <el-option label="地市" value="地市"></el-option>
                                    <el-option label="浙江" value="浙江"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item size="small" label="岗位" label-width="150px">
                                <el-select v-model="fulluser.sysUser.DutyId" placeholder="请选择岗位">
                                    <el-option v-for="v in duty" :label="v.ClassName" :key="v.Id"
                                        :value="v.Id"></el-option>
                                    <!-- <el-option label="区域二" value="beijing"></el-option> -->
                                </el-select>
                            </el-form-item>
                            <el-form-item size="small" label="工作地点" label-width="150px" prop="workPlace">
                                <el-select v-model="fulluser.userBase.WorkPlace" placeholder="请选择工作地点">
                                    <el-option label="产业园" value="产业园"></el-option>
                                    <el-option label="双子塔" value="双子塔"></el-option>
                                    <el-option label="曼哈顿" value="曼哈顿"></el-option>
                                    <el-option label="北环" value="北环"></el-option>
                                    <el-option label="平顶山" value="平顶山"></el-option>
                                    <el-option label="三门峡" value="三门峡"></el-option>
                                    <el-option label="驻马店" value="驻马店"></el-option>
                                    <el-option label="许昌" value="许昌"></el-option>
                                    <el-option label="商丘" value="商丘"></el-option>
                                    <el-option label="漯河" value="漯河"></el-option>
                                    <el-option label="南阳" value="南阳"></el-option>
                                    <el-option label="濮阳" value="濮阳"></el-option>
                                    <el-option label="开封" value="开封"></el-option>
                                    <el-option label="信阳" value="信阳"></el-option>
                                    <el-option label="鹤壁" value="鹤壁"></el-option>
                                    <el-option label="周口" value="周口"></el-option>
                                    <el-option label="新乡" value="新乡"></el-option>
                                    <el-option label="洛阳" value="洛阳"></el-option>
                                    <el-option label="杭州" value="杭州"></el-option>
                                    <el-option label="大连" value="大连"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item size="small" label="身份证号" label-width="150px" prop="idNum">
                                <el-input v-model="fulluser.userBase.IDNum"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>身份证图片</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row class="font_left">
                <el-col :span="6">
                    <div>
                        <el-col style="text-align:right;font-size:14px;" :span="9">身份证(人像面)：</el-col>
                        <el-col style="text-align:left;" :span="15">

                            <el-upload accept="image/jpeg,image/gif,image/png,image/jpg" action=""
                                :data="{ name: 'userBase.IDCardAttachPositive' }" :http-request="uploadImage"
                                class="avatar-uploader el-upload" :before-upload="beforeAvatarUpload">
                                <!-- @click.native="tanchukuang(fulluser.userBase.IDCardAttachPositive)"         -->
                                <img v-if="fulluser.userBase.IDCardAttachPositive"
                                    :src="fulluser.userBase.IDCardAttachPositive" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-col>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div>
                        <el-col style="text-align:right;font-size:14px;" :span="9">身份证(国徽面)：</el-col>
                        <el-col style="text-align:left;" :span="15">
                            <el-upload accept="image/jpeg,image/gif,image/png,image/jpg" action=""
                                :data="{ name: 'userBase.IDCardAttachOppsite' }" :http-request="uploadImage"
                                class="avatar-uploader el-upload" :before-upload="beforeAvatarUpload"><img
                                    v-if="fulluser.userBase.IDCardAttachOppsite"
                                    :src="fulluser.userBase.IDCardAttachOppsite" class="avatar"><i v-else
                                    class="el-icon-plus avatar-uploader-icon"></i></el-upload>
                        </el-col>
                    </div>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>联系信息</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row class="font_left">
                <el-col :span="6">
                    <el-form-item size="small" label="公司手机号" label-width="150px" prop="name">
                        <el-input v-model="fulluser.userContact.CompanyPhone"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="籍贯" label-width="150px" prop="nativePlace">
                        <el-input v-model="fulluser.userContact.NativePlace"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="个人手机号" label-width="150px" prop="personalPhone">
                        <el-input v-model="fulluser.userContact.PersonalPhone"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="户籍类型" label-width="150px" prop="residenceType">
                        <el-select v-model="fulluser.userContact.ResidenceType" placeholder="请选择户籍类型">
                            <el-option label="本地城镇" value="本地城镇"></el-option>
                            <el-option label="外地城镇" value="外地城镇"></el-option>
                            <el-option label="本地农村" value="本地农村"></el-option>
                            <el-option label="外地农村" value="外地农村"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="现住址" label-width="150px" prop="nowAddress">
                        <el-input v-model="fulluser.userContact.NowAddress"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="户籍地址" label-width="150px" prop="address">
                        <el-input v-model="fulluser.userContact.Address"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>合同信息</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row class="font_left">
                <el-col :span="6">
                    <el-form-item size="small" label="用工类型" label-width="150px" prop="contractType">
                        <el-select v-model="fulluser.userContract.ContractType" placeholder="请选择用工类型">
                            <el-option label="全职" value="全职"></el-option>
                            <el-option label="兼职" value="兼职"></el-option>
                            <el-option label="实习生" value="实习生"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="合同开始时间" label-width="150px">
                        <el-form-item prop="contractBegin">
                            <el-date-picker type="date" placeholder="选择合同开始时间"
                                v-model="fulluser.userContract.ContractBegin" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="合同结束时间" label-width="150px">
                        <el-form-item prop="contractEnd">
                            <el-date-picker type="date" placeholder="选择合同结束时间"
                                v-model="fulluser.userContract.ContractEnd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>紧急联系人</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row class="font_left">
                <el-col :span="6">
                    <el-form-item size="small" label="关系" label-width="150px" prop="linkType">
                        <el-select v-model="fulluser.userEmergency.LinkType" placeholder="请选择紧急联系人关系">
                            <el-option label="父亲" value="父亲"></el-option>
                            <el-option label="母亲" value="母亲"></el-option>
                            <el-option label="配偶" value="配偶"></el-option>
                            <el-option label="儿子" value="儿子"></el-option>
                            <el-option label="女儿" value="女儿"></el-option>
                            <el-option label="兄妹" value="兄妹"></el-option>
                            <el-option label="兄弟" value="兄弟"></el-option>
                            <el-option label="姐弟" value="姐弟"></el-option>
                            <el-option label="姐妹" value="姐妹"></el-option>
                            <el-option label="朋友" value="朋友"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="联系人姓名" label-width="150px" prop="linkName">
                        <el-input v-model="fulluser.userEmergency.LinkName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="联系人电话" label-width="150px" prop="linkPhone">
                        <el-input v-model="fulluser.userEmergency.LinkPhone"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>教育信息</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row class="font_left">
                <el-col :span="6">
                    <el-form-item size="small" label="最高学历" label-width="150px" prop="highestEducation">
                        <el-select v-model="fulluser.userEducation.HighestEducation" placeholder="请选择最高学历">
                            <el-option label="小学" value="小学"></el-option>
                            <el-option label="初中" value="初中"></el-option>
                            <el-option label="高中" value="高中"></el-option>
                            <el-option label="中专" value="中专"></el-option>
                            <el-option label="专科" value="专科"></el-option>
                            <el-option label="本科" value="本科"></el-option>
                            <el-option label="硕士" value="硕士"></el-option>
                            <el-option label="博士" value="博士"></el-option>
                            <el-option label="姐妹" value="姐妹"></el-option>
                            <el-option label="博士后" value="博士后"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item size="small" label="所学专业" label-width="150px" prop="subject">
                        <el-input v-model="fulluser.userEducation.Subject"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="毕业时间" label-width="150px" prop="graduateDate">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="选择毕业时间"
                                v-model="fulluser.userEducation.GraduateDate" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="毕业院校" label-width="150px" prop="graduateSchool">
                        <el-input v-model="fulluser.userEducation.GraduateSchool"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class=" mar_top_10">
                <el-col :span="6">
                    <div>
                        <!-- <el-col :span="4"></el-col> -->
                        <el-col style="text-align:right;font-size:14px;" :span="9">学位证书：</el-col>
                        <el-col style="text-align:left;" :span="15">
                            <el-upload accept="image/jpeg,image/gif,image/png,image/jpg" action=""
                                :data="{ name: 'userEducation.DegreeAttach' }" :http-request="uploadImage"
                                class="avatar-uploader el-upload" :before-upload="beforeAvatarUpload"><img
                                    v-if="fulluser.userEducation.DegreeAttach"
                                    :src="fulluser.userEducation.DegreeAttach" class="avatar"><i v-else
                                    class="el-icon-plus avatar-uploader-icon"></i></el-upload>
                        </el-col>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div>
                        <el-col style="text-align:right;font-size:14px;" :span="9">学历证书：</el-col>
                        <el-col style="text-align:left;" :span="15">
                            <el-upload accept="image/jpeg,image/gif,image/png,image/jpg" action=""
                                :data="{ name: 'userEducation.EducationAttach' }" :http-request="uploadImage"
                                class="avatar-uploader el-upload" :before-upload="beforeAvatarUpload"><img
                                    v-if="fulluser.userEducation.EducationAttach"
                                    :src="fulluser.userEducation.EducationAttach" class="avatar"><i v-else
                                    class="el-icon-plus avatar-uploader-icon"></i></el-upload>
                        </el-col>
                    </div>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>婚姻状况</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row class="font_left">
                <el-col :span="6">
                    <el-form-item label="婚姻状况" label-width="150px" prop="MarriageStatus">
                        <el-select v-model="fulluser.userFamily.MarriageStatus" placeholder="请选择婚姻状况">
                            <el-option label="单身" value="单身"></el-option>
                            <el-option label="已婚" value="已婚"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="子女性别" label-width="150px" prop="name">
                        <el-select v-model="fulluser.userFamily.ChildGender" placeholder="请选择子女性别">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="结婚纪念日" label-width="150px">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="选择结婚纪念日" v-model="fulluser.userFamily.MarriageDay"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="子女生日" label-width="150px">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="选择子女生日" v-model="fulluser.userFamily.ChildBirthday"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="是否生育" label-width="150px" prop="isHaveChild">
                        <el-select v-model="fulluser.userFamily.IsHaveChild" placeholder="请选择是否生育">
                            <el-option label="否" value="否"></el-option>
                            <el-option label="是" value="是"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>资质信息</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row class="font_left">
                <el-col :span="6">
                    <el-form-item label="资质名称" label-width="150px" prop="name">
                        <el-input v-model="fulluser.userQualification.QualificationName"></el-input>
                    </el-form-item>
                    <div class="mar_top_10">
                        <el-col style="text-align:right;font-size:14px;" :span="9">资质证书：</el-col>
                        <el-col style="text-align:left;" :span="15">
                            <el-upload accept="image/jpeg,image/gif,image/png,image/jpg" action=""
                                :data="{ name: 'userQualification.QualificationAttach' }" :http-request="uploadImage"
                                class="avatar-uploader el-upload" :before-upload="beforeAvatarUpload"><img
                                    v-if="fulluser.userQualification.QualificationAttach"
                                    :src="fulluser.userQualification.QualificationAttach" class="avatar"><i v-else
                                    class="el-icon-plus avatar-uploader-icon"></i></el-upload>
                        </el-col>
                    </div>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="资质获得时间" label-width="150px">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="选择资质获得时间"
                                v-model="fulluser.userQualification.QualificationDate"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="font_left">
                <el-col :span="24">
                    <div>
                        <h1>工作经历</h1>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-bottom:20px;" v-for="item in fulluser.userWorkHistory" :key="item.ID"
                class="font_left">
                <el-col :span="6">
                    <el-form-item size="small" label="公司名称" label-width="150px" prop="companyName">
                        <el-input v-model="item.CompanyName"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="所任职务" label-width="150px" prop="position">
                        <el-input v-model="item.Position"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="离职原因" label-width="150px" prop="leaveReason">
                        <el-input v-model="item.LeaveReason"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="公司性质" label-width="150px" prop="companyType">
                        <el-input v-model="item.CompanyType"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="开始时间" label-width="150px" prop="beginDate">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" format="yyyy-MM-dd" placeholder="选择开始时间"
                                v-model="item.BeginDate" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item size="small" label="同事电话" label-width="150px" prop="workmatePhone">
                        <el-input v-model="item.WorkmatePhone"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item size="small" label="公司规模" label-width="150px" prop="size">
                        <el-input v-model="item.Size"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="结束时间" label-width="150px" prop="endDate">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" format="yyyy-MM-dd" placeholder="选择结束时间" v-model="item.EndDate"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
                <el-col style="text-align:center;" :span="2">
                    <el-button type="danger" @click="removeDomain(item)" plain size="mini">删除</el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20" style="text-align:right;">
                    <el-button type="primary" icon="el-icon-plus" @click="addCompany" plain size="mini">新增一条</el-button>
                </el-col>
                <el-col :span="2">
                </el-col>
            </el-row>
            <div class="border_bottom"></div>
            <el-row class="mar_top_20">
                <el-button type="primary" @click="submitForm(fulluser)">保存</el-button>
                <el-button @click="cancle">取消</el-button>
            </el-row>
        </el-form>

        <!-- <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
            <img  :src="dialogImage" class="avatar">
        </el-dialog> -->
    </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { getUrlKey } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { GetSysItemListByParentID } from "../../until/ZeusApiSDK/Logic/SysItemLogic";
import { GetSingeleUser, GeteUserBaseList, GetUserContactList, GetUserContractList, GetUseEducationList, GetUseEmergencyList, GetUseFamilyList, GetUseQualificationList, GetUseWorkHistoryList, CheckUserBaseFiledOnly, CheckUserFiledOnly, GetBirthday, GetGender, UpdateFullUser } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { GetGuid } from '../../until/ZeusApiSDK/Logic/HomeLogic';
import { PostProxyByUrl } from '../../until/ZeusApiSDK/ZeusAPIClient';
import { EnqueueFullUser } from '../../until/ZeusApiSDK/Logic/LogLogic';
export default {
    data() {
        return {
            currentUser: {},//当前登录用户信息
            userId: '',//当前用户id
            type: [],//薪资体系
            dutyType: [],//岗位类别
            duty: [],//岗位
            drawer: false,//是否打开抽屉
            oldFullUser: {
                sysUser: {
                    Id: '',
                    EnterpriseWeChatId: '',
                    DingId: '',
                    Region: '',
                    CompanyName: '',
                    CompanyID: '',
                    CenterName: '',
                    CenterID: '',
                    KernelName: '',
                    KernelID: '',
                    GroupName: '',
                    GroupID: '',
                    MainDeptsName: '',
                    MainDeptsID: '',
                    OtherDeptsNames: '',
                    OtherDeptsIDs: '',
                    PositionId: '',
                    PositionName: '',
                    DutyTypeId: '',
                    DutyType: '',
                    DutyId: '',
                    Duty: '',
                    UserName: '',
                    UserPwd: '',
                    TrueName: '',
                    UserCode: '',
                    Phone: '',
                    Demo: '',
                    AddTime: '',
                    LastLoginTime: '',
                    LastLoginIp: '',
                    IsLock: '',
                    IsDel: '',
                    TimeStamp: '',
                    Sflag: '',
                    HeadImg: '',
                    FileStatus: '',
                    Status: '',
                    FullPath: '',
                    UnionId: '',
                    OpenId: '',
                },//用户基本信息
                userBase: {
                    ID: '',
                    UserID: '',
                    SalaryType: '',
                    SalaryID: '',
                    RankName: '',
                    RankID: '',
                    LevelName: '',
                    LevelID: '',
                    HiredDate: '',
                    SalaryDate: '',
                    IsRegular: '',
                    RegularDate: '',
                    Politcal: '',
                    WorkPlace: '',
                    InsuranceStatus: '',
                    RecruitIncome: '',
                    Gender: '',
                    BirthDay: '',
                    Nature: '',
                    IDNum: '',
                    IDCardAttachPositive: '',
                    IDCardAttachOppsite: '',
                    IsPossess: '',
                    CardNo: '',
                    ExpirationTime: '',
                    PSB: '',
                },//用户基本信息
                userContact: {
                    ID: '',
                    UserID: '',
                    CompanyPhone: '',
                    PersonalPhone: '',
                    EamilStatus: '',
                    DingStatus: '',
                    NativePlace: '',
                    ResidenceType: '',
                    Address: '',
                    NowAddress: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//用户联系信息
                userContract: {
                    ID: '',
                    UserID: '',
                    ContractBegin: '',
                    ContractEnd: '',
                    ContractType: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//用户合同信息
                userEducation: {
                    ID: '',
                    UserID: '',
                    HighestEducation: '',
                    GraduateDate: '',
                    GraduateSchool: '',
                    EducationAttach: '',
                    DegreeAttach: '',
                    Subject: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//用户教育信息
                userEmergency: {
                    ID: '',
                    UserID: '',
                    LinkName: '',
                    LinkType: '',
                    LinkPhone: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//紧急联系人信息
                userFamily: {
                    ID: '',
                    UserID: '',
                    MaternityLeaveBegin: '',
                    MaternityLeaveEnd: '',
                    MarriageStatus: '',
                    MarriageDay: '',
                    IsHaveChild: '',
                    ChildGender: '',
                    ChildBirthday: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//家庭信息
                userQualification: {
                    ID: '',
                    UserID: '',
                    QualificationName: '',
                    QualificationDate: '',
                    QualificationAttach: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//资质信息
                userWorkHistory: [],//工作经历
            },//修改前数据信息
            fulluser: {//用户全部信息
                sysUser: {
                    Id: '',
                    EnterpriseWeChatId: '',
                    DingId: '',
                    Region: '',
                    CompanyName: '',
                    CompanyID: '',
                    CenterName: '',
                    CenterID: '',
                    KernelName: '',
                    KernelID: '',
                    GroupName: '',
                    GroupID: '',
                    MainDeptsName: '',
                    MainDeptsID: '',
                    OtherDeptsNames: '',
                    OtherDeptsIDs: '',
                    PositionId: '',
                    PositionName: '',
                    DutyTypeId: '',
                    DutyType: '',
                    DutyId: '',
                    Duty: '',
                    UserName: '',
                    UserPwd: '',
                    TrueName: '',
                    UserCode: '',
                    Phone: '',
                    Demo: '',
                    AddTime: '',
                    LastLoginTime: '',
                    LastLoginIp: '',
                    IsLock: '',
                    IsDel: '',
                    TimeStamp: '',
                    Sflag: '',
                    HeadImg: '',
                    FileStatus: '',
                    Status: '',
                    FullPath: '',
                    UnionId: '',
                    OpenId: '',
                },//用户基本信息
                userBase: {
                    ID: '',
                    UserID: '',
                    SalaryType: '',
                    SalaryID: '',
                    RankName: '',
                    RankID: '',
                    LevelName: '',
                    LevelID: '',
                    HiredDate: '',
                    SalaryDate: '',
                    IsRegular: '',
                    RegularDate: '',
                    Politcal: '',
                    WorkPlace: '',
                    InsuranceStatus: '',
                    RecruitIncome: '',
                    Gender: '',
                    BirthDay: '',
                    Nature: '',
                    IDNum: '',
                    IDCardAttachPositive: '',
                    IDCardAttachOppsite: '',
                    IsPossess: '',
                    CardNo: '',
                    ExpirationTime: '',
                    PSB: '',
                },//用户基本信息
                userContact: {
                    ID: '',
                    UserID: '',
                    CompanyPhone: '',
                    PersonalPhone: '',
                    EamilStatus: '',
                    DingStatus: '',
                    NativePlace: '',
                    ResidenceType: '',
                    Address: '',
                    NowAddress: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//用户联系信息
                userContract: {
                    ID: '',
                    UserID: '',
                    ContractBegin: '',
                    ContractEnd: '',
                    ContractType: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//用户合同信息
                userEducation: {
                    ID: '',
                    UserID: '',
                    HighestEducation: '',
                    GraduateDate: '',
                    GraduateSchool: '',
                    EducationAttach: '',
                    DegreeAttach: '',
                    Subject: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//用户教育信息
                userEmergency: {
                    ID: '',
                    UserID: '',
                    LinkName: '',
                    LinkType: '',
                    LinkPhone: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//紧急联系人信息
                userFamily: {
                    ID: '',
                    UserID: '',
                    MaternityLeaveBegin: '',
                    MaternityLeaveEnd: '',
                    MarriageStatus: '',
                    MarriageDay: '',
                    IsHaveChild: '',
                    ChildGender: '',
                    ChildBirthday: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//家庭信息
                userQualification: {
                    ID: '',
                    UserID: '',
                    QualificationName: '',
                    QualificationDate: '',
                    QualificationAttach: '',
                    IsDelete: '',
                    DeleteTime: '',
                },//资质信息
                userWorkHistory: [{
                    ID: '',
                    UserID: '',
                    CompanyName: '',
                    BeginDate: '',
                    EndDate: '',
                    CompanyType: '',
                    Size: '',
                    Position: '',
                    LeaveReason: '',
                    WorkmatePhone: '',
                    IsDelete: '',
                    DeleteTime: '',
                }],//工作经历
            },

            imageUrl: '',//上传图片路径地址
            //表单规则验证
            rules: {
            },
            dialogVisible: false,//是否显示弹框
            dialogImage: '',//图片
            dialogTitle: '',//弹出框标题
        }
    },
    methods: {
        //获取当前用户
        getCurrentUser: function () {
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取当前用户信息
        getUserInfo: function () {
            //var userId=this.currentUser.UserId;
            //获取sysuser基本信息
            GetSingeleUser(this.userId, 'RzqZeusStructureGetFullUser').then(res => {
                this.oldFullUser.sysUser = res;
                this.fulluser.sysUser = res;
            });
            //构造参数
            var predicates = [{
                Field: "UserID",
                Value: this.userId,
                Oper: "eq",
                IsAnd: 1
            }];
            //获取userBase基本信息
            GeteUserBaseList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userBase = res[0];
                    this.fulluser.userBase = res[0];
                    this.fulluser.userBase.IsPossess = this.fulluser.userBase.IsPossess == 0 ? '否' : '是';
                }
            });
            //获取userContact用户联系基本信息
            GetUserContactList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userContact = res[0];
                    this.fulluser.userContact = res[0];
                }
            });
            //获取userContract用户合同信息
            GetUserContractList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userContract = res[0];
                    this.fulluser.userContract = res[0];
                }
            });
            //获取userEducation教育信息
            GetUseEducationList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userEducation = res[0];
                    this.fulluser.userEducation = res[0];
                }
            });
            //获取userEmergency紧急联系人信息
            GetUseEmergencyList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userEmergency = res[0];
                    this.fulluser.userEmergency = res[0];
                }
            });
            //获取userFamily家庭信息
            GetUseFamilyList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userFamily = res[0];
                    this.fulluser.userFamily = res[0];
                    this.fulluser.userFamily.MarriageStatus = this.fulluser.userFamily.MarriageStatus ? '已婚' : '单身';
                    this.fulluser.userFamily.IsHaveChild = this.fulluser.userFamily.IsHaveChild ? '是' : '否';
                    this.fulluser.userFamily.ChildGender = this.fulluser.userFamily.ChildGender == 1 ? '男' : '女';
                }
            });
            //获取userQualification资质信息
            GetUseQualificationList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userQualification = res[0];
                    this.fulluser.userQualification = res[0];
                }
            });
            //获取userWorkHistory工作经历信息
            GetUseWorkHistoryList(predicates).then(res => {
                if (res.length > 0) {
                    this.oldFullUser.userWorkHistory = res;
                    this.fulluser.userWorkHistory = res;
                }
            });
        },
        //图片上传成功路径显示
        uploadImage: function (item) {
            // // FormData 对象
            const formData = new FormData();
            // 文件对象
            formData.append('file', item.file);
            //图片上传
            this.$http.post('http://eapi.ruizhiqi.cn/api/upload/uploadformdata', formData).then(res => {
                if (res.data.Data.Result == 1) {
                    if (item.data.name == "sysUser.HeadImg") {
                        //头像
                        if (res.data.Data.Message != null && res.data.Data.Message.indexOf('https') != -1) {
                            //存在字符串
                            this.fulluser.sysUser.HeadImg = res.data.Data.Message.replace("https", "http");
                        }
                        else {
                            this.fulluser.sysUser.HeadImg = res.data.Data.Message;
                        }

                    }
                    else if (item.data.name == "userBase.IDCardAttachPositive") {
                        //身份证(人像面)
                        if (res.data.Data.Message != null && res.data.Data.Message.indexOf('https') != -1) {
                            //存在字符串
                            this.fulluser.userBase.IDCardAttachPositive = res.data.Data.Message.replace("https", "http");
                        }
                        else {
                            this.fulluser.userBase.IDCardAttachPositive = res.data.Data.Message;
                        }
                    }
                    else if (item.data.name == "userBase.IDCardAttachOppsite") {
                        //身份证国徽面
                        if (res.data.Data.Message != null && res.data.Data.Message.indexOf('https') != -1) {
                            //存在字符串
                            this.fulluser.userBase.IDCardAttachOppsite = res.data.Data.Message.replace("https", "http");
                        }
                        else {
                            this.fulluser.userBase.IDCardAttachOppsite = res.data.Data.Message;
                        }
                    }
                    else if (item.data.name == "userQualification.QualificationAttach") {
                        //资质证书
                        if (res.data.Data.Message != null && res.data.Data.Message.indexOf('https') != -1) {
                            //存在字符串
                            this.fulluser.userQualification.QualificationAttach = res.data.Data.Message.replace("https", "http");
                        }
                        else {
                            this.fulluser.userQualification.QualificationAttach = res.data.Data.Message;
                        }

                    }
                    else if (item.data.name == "userEducation.DegreeAttach") {
                        //学位证书
                        if (res.data.Data.Message != null && res.data.Data.Message.indexOf('https') != -1) {
                            //存在字符串
                            this.fulluser.userEducation.DegreeAttach = res.data.Data.Message.replace("https", "http");
                        }
                        else {
                            this.fulluser.userEducation.DegreeAttach = res.data.Data.Message;
                        }
                    }
                    else if (item.data.name == "userEducation.EducationAttach") {
                        //学历证书
                        if (res.data.Data.Message != null && res.data.Data.Message.indexOf('https') != -1) {
                            //存在字符串
                            this.fulluser.userEducation.EducationAttach = res.data.Data.Message.replace("https", "http");
                        }
                        else {
                            this.fulluser.userEducation.EducationAttach = res.data.Data.Message;
                        }
                    }
                } else {
                    this.$message.error('图片上传失败');
                }
            });
        },
        //图片上传
        beforeAvatarUpload: function (file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
        //获取薪资体系，岗位类别，岗位信息等
        GetSysItemListByParentID: function () {
            //获取薪酬体系
            GetSysItemListByParentID('9').then(res => {
                this.type = res;
            });
            //获取岗位类别
            GetSysItemListByParentID('7').then(res => {
                this.dutyType = res;
            });
            //获取岗位
            GetSysItemListByParentID('8').then(res => {
                this.duty = res;
            });
        },
        //添加工作经历
        addCompany: function () {
            this.fulluser.userWorkHistory.push({
                CompanyName: '',//公司名称
                Position: '',//所任职务
                LeaveReason: '',//离职原因
                CompanyType: '',//公司性质
                BeginDate: '',//开始时间
                EndDate: '',//结束时间
                WorkmatePhone: '',//同事电话
                Size: '',//公司规模
                ID: '',//主键id
                UserID: '',
            });
        },
        //删除工作经历
        removeDomain(item) {
            var index = this.fulluser.userWorkHistory.indexOf(item)
            if (index !== -1) {
                this.fulluser.userWorkHistory.splice(index, 1)
            }
        },
        //提交信息
        submitForm: async function (formInfo) {
            //前端判断
            if (formInfo.sysUser.Region == null || formInfo.sysUser.Region == '') {
                alert('请选择地区');
                return false;
            }
            if (formInfo.userBase.HiredDate == null || formInfo.userBase.HiredDate == '') {
                alert('请选择入职时间');
                return false;
            }
            if (formInfo.userBase.WorkPlace == null || formInfo.userBase.WorkPlace == '') {
                alert('请选择工作地点');
                return false;
            }
            if (formInfo.userBase.Politcal == null || formInfo.userBase.Politcal == '') {
                alert('请选择政治面貌');
                return false;
            }
            if (formInfo.userBase.Nature == null || formInfo.userBase.Nature == '') {
                alert('请输入民族');
                return false;
            }
            if (formInfo.userBase.IDNum == null || formInfo.userBase.IDNum == '') {
                alert('请输入身份证号');
                return false;
            }
            if (formInfo.userBase.PSB == null || formInfo.userBase.PSB == '') {
                alert('请输入身份证签发机关');
                return false;
            }
            if (formInfo.userBase.ExpirationTime == null || formInfo.userBase.ExpirationTime == '') {
                alert('请选择身份证截止日期');
                return false;
            }
            /*if (formInfo.userBase.IsPossess == null || formInfo.userBase.IsPossess == '') {
                alert('请选择持有银行的工资卡');
                return false;
            }*/
            if (formInfo.sysUser.Phone == null || formInfo.sysUser.Phone == '') {
                alert('请输入个人手机号');
                return false;
            }
            if (formInfo.userContact.NowAddress == null || formInfo.userContact.NowAddress == '') {
                alert('请输入现住址');
                return false;
            }
            if (formInfo.userContact.NativePlace == null || formInfo.userContact.NativePlace == '') {
                alert('请输入籍贯');
                return false;
            }
            if (formInfo.userContact.ResidenceType == null || formInfo.userContact.ResidenceType == '') {
                alert('请选择户籍类型');
                return false;
            }
            if (formInfo.userContact.Address == null || formInfo.userContact.Address == '') {
                alert('请输入户籍地址');
                return false;
            }
            if (formInfo.userContract.ContractType == null || formInfo.userContract.ContractType == '') {
                alert('请选择用工类型');
                return false;
            }
            if (formInfo.userContract.ContractBegin == null || formInfo.userContract.ContractBegin == '') {
                alert('请选择合同开始时间');
                return false;
            }
            if (formInfo.userContract.ContractEnd == null || formInfo.userContract.ContractEnd == '') {
                alert('请选择合同结束时间');
                return false;
            }
            if (formInfo.userEmergency.LinkType == null || formInfo.userEmergency.LinkType == '') {
                alert('请选择紧急联系人关系');
                return false;
            }
            if (formInfo.userEmergency.LinkName == null || formInfo.userEmergency.LinkName == '') {
                alert('请输入联系人姓名');
                return false;
            }
            if (formInfo.userEmergency.LinkPhone == null || formInfo.userEmergency.LinkPhone == '') {
                alert('请输入联系人电话');
                return false;
            }
            if (formInfo.userEducation.HighestEducation == null || formInfo.userEducation.HighestEducation == '') {
                alert('请选择最高学历');
                return false;
            }
            if (formInfo.userEducation.GraduateDate == null || formInfo.userEducation.GraduateDate == '') {
                alert('请选择毕业时间');
                return false;
            }
            if (formInfo.userEducation.GraduateSchool == null || formInfo.userEducation.GraduateSchool == '') {
                alert('请输入毕业院校');
                return false;
            }
            if (formInfo.userEducation.Subject == null || formInfo.userEducation.Subject == '') {
                alert('请输入所学专业');
                return false;
            }
            if (formInfo.userFamily.MarriageStatus == null || formInfo.userFamily.MarriageStatus == '') {
                alert('请选择婚姻状况');
                return false;
            }
            if (formInfo.userFamily.IsHaveChild == null || formInfo.userFamily.IsHaveChild == '') {
                alert('请选择是否生育');
                return false;
            }


            //判断身份证号是否重复
            var checkIdNum = false;
            var predicates = [{
                Field: "IDNum",
                Value: formInfo.userBase.IDNum,
                Oper: "eq",
                IsAnd: 1
            }, {
                Field: "UserID",
                Value: formInfo.userBase.UserID,
                Oper: "neq",
                IsAnd: 1
            }];
            CheckUserBaseFiledOnly(predicates).then(res => {
                checkIdNum = res;
            });
            if (checkIdNum) {
                alert('身份证号重复，请联系管理员');
                return false;
            }
            //证件照
            if (formInfo.sysUser.HeadImg == '' || formInfo.sysUser.HeadImg == null || formInfo.sysUser.HeadImg == 'undefined') {
                this.$message.error('请上传证件照');
                return false;
            }
            //请上传（身份证国徽面照片）
            if (formInfo.userBase.IDCardAttachPositive == '' || formInfo.userBase.IDCardAttachPositive == null || formInfo.userBase.IDCardAttachPositive == 'undefined') {
                alert('请上传（身份证国徽面照片）');
                return false;
            }
            //请上传（身份证信息面照片）
            if (formInfo.userBase.IDCardAttachOppsite == '' || formInfo.userBase.IDCardAttachOppsite == null || formInfo.userBase.IDCardAttachOppsite == 'undefined') {
                alert('请上传（身份证信息面照片）');
                return false;
            }
            //请上传学历证书
            if (formInfo.userEducation.EducationAttach == '' || formInfo.userEducation.EducationAttach == null || formInfo.userEducation.EducationAttach == 'undefined') {
                alert('请上传学历证书');
                return false;
            }

            //判断邮箱是否存在
            var checkUserName = false;
            var predicatesUser = [{
                Field: "UserName",
                Value: formInfo.sysUser.UserName,
                Oper: "eq",
                IsAnd: 1
            }, {
                Field: "IsDel",
                Value: 'false',
                Oper: "eq",
                IsAnd: 1
            }, {
                Field: "Id",
                Value: formInfo.sysUser.Id,
                Oper: "neq",
                IsAnd: 1
            }];
            CheckUserFiledOnly(predicatesUser).then(res => {
                checkUserName = res;
            })
            if (checkUserName) {
                this.$message.error('公司邮箱重复');
                return false;
            }

            //添加编辑数据
            formInfo.sysUser.FileStatus = "1";//更新档案状态
            formInfo.userBase.BirthDay = GetBirthday(formInfo.userBase.IDNum);
            formInfo.userBase.Gender = GetGender(formInfo.userBase.IDNum);
            if (formInfo.userBase.ID == '' || formInfo.userBase.ID == null) {
                formInfo.userBase.ID = await GetGuid();
                formInfo.userBase.UserID = formInfo.sysUser.Id;
            }
            if (formInfo.userContact.ID == '' || formInfo.userContact.ID == null) {
                formInfo.userContact.ID = await GetGuid();
                formInfo.userContact.UserID = formInfo.sysUser.Id;
            }
            if (formInfo.userContract.ID == '' || formInfo.userContract.ID == null) {
                formInfo.userContract.ID = await GetGuid();
                formInfo.userContract.UserID = formInfo.sysUser.Id;
            }
            if (formInfo.userEducation.ID == '' || formInfo.userEducation.ID == null) {
                formInfo.userEducation.ID = await GetGuid();
                formInfo.userEducation.UserID = formInfo.sysUser.Id;
            }
            if (formInfo.userEmergency.ID == '' || formInfo.userEmergency.ID == null) {
                formInfo.userEmergency.ID = await GetGuid();
                formInfo.userEmergency.UserID = formInfo.sysUser.Id;
            }
            if (formInfo.userFamily.ID == '' || formInfo.userFamily.ID == null) {
                formInfo.userFamily.ID = await GetGuid();
                formInfo.userFamily.UserID = formInfo.sysUser.Id;
            }
            if (formInfo.userQualification.ID == '' || formInfo.userQualification.ID == null) {
                formInfo.userQualification.ID = await GetGuid();
                formInfo.userQualification.UserID = formInfo.sysUser.Id;
            }

            //转换入职时间  时间格式
            if (formInfo.userBase.HiredDate != '' && formInfo.userBase.HiredDate != null) {
                const hired = new Date(formInfo.userBase.HiredDate);
                const hiredDate = hired.getFullYear() + '-' + this.p((hired.getMonth() + 1)) + '-' + this.p(hired.getDate());
                formInfo.userBase.HiredDate = hiredDate;
            }

            //转换身份证截止日期 时间格式
            if (formInfo.userBase.ExpirationTime != '' && formInfo.userBase.ExpirationTime != null) {
                const expiration = new Date(formInfo.userBase.ExpirationTime);
                const expirationTime = expiration.getFullYear() + '-' + this.p((expiration.getMonth() + 1)) + '-' + this.p(expiration.getDate());
                formInfo.userBase.ExpirationTime = expirationTime;
            }

            //转换合同开始时间 
            if (formInfo.userContract.ContractBegin != '' && formInfo.userContract.ContractBegin != null) {
                const contractBegin = new Date(formInfo.userContract.ContractBegin);
                const contractBeginTime = contractBegin.getFullYear() + '-' + this.p((contractBegin.getMonth() + 1)) + '-' + this.p(contractBegin.getDate());
                formInfo.userContract.ContractBegin = contractBeginTime;
            }

            //转换合同结束时间 fulluser.userContract.ContractEnd
            if (formInfo.userContract.ContractEnd != '' && formInfo.userContract.ContractEnd != null) {
                const contractEnd = new Date(formInfo.userContract.ContractEnd);
                const contractEndTime = contractEnd.getFullYear() + '-' + this.p((contractEnd.getMonth() + 1)) + '-' + this.p(contractEnd.getDate());
                formInfo.userContract.ContractEnd = contractEndTime;
            }

            //转换毕业时间  fulluser.userEducation.GraduateDate
            if (formInfo.userEducation.GraduateDate != '' && formInfo.userEducation.GraduateDate != null) {
                const graduate = new Date(formInfo.userEducation.GraduateDate);
                const graduateDate = graduate.getFullYear() + '-' + this.p((graduate.getMonth() + 1)) + '-' + this.p(graduate.getDate());
                formInfo.userEducation.GraduateDate = graduateDate;
            }

            //转换结婚纪念日   fulluser.userFamily.MarriageDay
            if (formInfo.userFamily.MarriageDay != '' && formInfo.userFamily.MarriageDay != null) {
                const marriage = new Date(formInfo.userFamily.MarriageDay);
                const marriageDate = marriage.getFullYear() + '-' + this.p((marriage.getMonth() + 1)) + '-' + this.p(marriage.getDate());
                formInfo.userFamily.MarriageDay = marriageDate;
            }

            //转换子女生日  fulluser.userFamily.ChildBirthday
            if (formInfo.userFamily.ChildBirthday != '' && formInfo.userFamily.ChildBirthday != null) {
                const childBirthday = new Date(formInfo.userFamily.ChildBirthday);
                const childBirthdayDate = childBirthday.getFullYear() + '-' + this.p((childBirthday.getMonth() + 1)) + '-' + this.p(childBirthday.getDate());
                formInfo.userFamily.ChildBirthday = childBirthdayDate;
            }

            //转换资质获得时间  fulluser.userQualification.QualificationDate
            if (formInfo.userQualification.QualificationDate != '' && formInfo.userQualification.QualificationDate != null) {
                const qualification = new Date(formInfo.userQualification.QualificationDate);
                const qualificationDate = qualification.getFullYear() + '-' + this.p((qualification.getMonth() + 1)) + '-' + this.p(qualification.getDate());
                formInfo.userQualification.QualificationDate = qualificationDate;
            }
            formInfo.userBase.IsPossess = formInfo.userBase.IsPossess == '否' ? 0 : 1;
            formInfo.userFamily.MarriageStatus = formInfo.userFamily.MarriageStatus == "已婚" ? 'true' : 'false';
            formInfo.userFamily.IsHaveChild = formInfo.userFamily.IsHaveChild == '是' ? 'true' : 'false';
            formInfo.userFamily.ChildGender = formInfo.userFamily.ChildGender == '男' ? 1 : 0;

            var isBreak = false;
            formInfo.userWorkHistory.forEach(async item => {
                if (item.CompanyName == '' || item.CompanyName == null || item.CompanyName == 'undefined') {
                    alert('请输入公司名称');
                    isBreak = true;
                    return false;
                }
                if (item.CompanyType == '' || item.CompanyType == null || item.CompanyType == 'undefined') {
                    alert('请输入公司性质');
                    isBreak = true;
                    return false;
                }
                if (item.Size == '' || item.Size == null || item.Size == 'undefined') {
                    alert('请输入公司规模');
                    isBreak = true;
                    return false;
                }
                if (item.Position == '' || item.Position == null || item.Position == 'undefined') {
                    alert('请输入所任职务');
                    isBreak = true;
                    return false;
                }
                if (item.BeginDate == '' || item.BeginDate == null || item.BeginDate == 'undefined') {
                    alert('请选择开始时间');
                    isBreak = true;
                    return false;
                }
                if (item.EndDate == '' || item.EndDate == null || item.EndDate == 'undefined') {
                    alert('请输入结束时间');
                    isBreak = true;
                    return false;
                }
                if (item.LeaveReason == '' || item.LeaveReason == null || item.LeaveReason == 'undefined') {
                    alert('请输入离职原因');
                    isBreak = true;
                    return false;
                }
                if (item.WorkmatePhone == '' || item.WorkmatePhone == null || item.WorkmatePhone == 'undefined') {
                    alert('请输入同事电话');
                    isBreak = true;
                    return false;
                }

                //转换工作经历开始时间
                if (item.BeginDate != '' && item.BeginDate != null) {
                    const beginDate = new Date(item.BeginDate);
                    const resbeginDate = beginDate.getFullYear() + '-' + this.p((beginDate.getMonth() + 1)) + '-' + this.p(beginDate.getDate());
                    item.BeginDate = resbeginDate;
                }
                //转换工作经历结束时间
                if (item.EndDate != '' && item.EndDate != null) {
                    const endDate = new Date(item.EndDate);
                    const resendDate = endDate.getFullYear() + '-' + this.p((endDate.getMonth() + 1)) + '-' + this.p(endDate.getDate());
                    item.EndDate = resendDate;
                }

                if (item.ID == '' || item.ID == null) {
                    item.ID = await GetGuid();
                    item.UserID = formInfo.sysUser.Id;
                }
            });

            //如果有值为空跳出方法
            if (isBreak) {
                return false;
            }

            //编辑信息
            UpdateFullUser(formInfo).then(res => {
                if (res) {
                    //编辑成功 添加日志
                    this.addLog(formInfo);

                    this.$router.push('/Structure/MyFile');
                } else {
                    this.$message.error('更新失败');
                    return false;
                }
            });


        },
        //取消 跳转到详情页
        cancle: function () {
            this.$router.push('/Structure/MyFile');
        },
        //时间转换 不够10 添加0
        p(s) {
            return s < 10 ? '0' + s : s
        },
        //添加日志
        addLog: function (formInfo) {
            //编辑sysUser成功，添加日志
            EnqueueFullUser("编辑档案sysUser",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.sysUser.Id,
                formInfo.sysUser,
                this.oldFullUser.sysUser,
                "sysUser");

            //编辑userBase成功，添加日志
            EnqueueFullUser("编辑档案userBase",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.userBase.Id,
                formInfo.userBase,
                this.oldFullUser.userBase,
                "userBase");

            //编辑userContact成功，添加日志
            EnqueueFullUser("编辑档案userContact",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.userContact.Id,
                formInfo.userContact,
                this.oldFullUser.userContact,
                "userContact");

            //编辑userContract成功，添加日志
            EnqueueFullUser("编辑档案userContract",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.userContract.Id,
                formInfo.userContract,
                this.oldFullUser.userContract,
                "userContract");

            //编辑userEducation成功，添加日志
            EnqueueFullUser("编辑档案userEducation",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.userEducation.Id,
                formInfo.userEducation,
                this.oldFullUser.userEducation,
                "userEducation");

            //编辑userEmergency成功，添加日志
            EnqueueFullUser("编辑档案userEmergency",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.userEmergency.Id,
                formInfo.userEmergency,
                this.oldFullUser.userEmergency,
                "userEmergency");

            //编辑userFamily成功，添加日志
            EnqueueFullUser("编辑档案userFamily",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.userFamily.Id,
                formInfo.userFamily,
                this.oldFullUser.userFamily,
                "userFamily");

            //编辑userQualification成功，添加日志
            EnqueueFullUser("编辑档案userQualification",
                this.oldFullUser.sysUser.Id,
                this.oldFullUser.sysUser.TrueName,
                "编辑",
                '更新成功',
                formInfo.userQualification.Id,
                formInfo.userQualification,
                this.oldFullUser.userQualification,
                "userQualification");

            formInfo.userWorkHistory.forEach(item => {
                //编辑uuserWorkHistory成功，添加日志
                EnqueueFullUser("编辑档案userWorkHistory",
                    this.oldFullUser.sysUser.Id,
                    this.oldFullUser.sysUser.TrueName,
                    "编辑",
                    '更新成功',
                    item.Id,
                    item,
                    item,
                    "userWorkHistory");
            });
        },
        //弹出框显示图片
        tanchukuang: function (imageUrl) {
        }
    },
    //页面进入加载事件
    created: function () {
        //当前用户id
        this.userId = getUrlKey('UserID');
        if (this.userId == '' || this.userId == null) {
            this.$router.push('/structure/MyFile');
        }
        //获取当前用户
        this.getCurrentUser();
        //获取当前用户信息
        this.getUserInfo();
        //获取薪资体系，岗位类别，岗位信息等
        this.GetSysItemListByParentID();
    },
}
</script>
<style lang="less" scoped>
.font_left {
    text-align: left;
}

.font_right {
    text-align: right;
}

.img_size {
    width: 100%;
    // padding:20px;
}

.img_size_80 {
    width: 60%;
    // padding:20px;
}

.div_name {
    font-size: 30px;
    margin-right: 30px;
}

.mar_top_10 {
    margin-top: 10px;
}

.mar_top_20 {
    margin-top: 20px;
}

.mar_left_10 {
    margin-right: 10px;
}

.border_bottom {
    margin-top: 26px;
    border-bottom: 1px dotted #d9d9d9;
}

.height_50 {
    height: 50px;
}

.height_45 {
    height: 45px;
}

//图片上传样式开始 .avatar-uploader
.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-select {
    width: 100%;
}

/deep/.el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
}

//图片上传样式结束</style>